import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  padding: ${spacing(5)};

  .rejectionFlagIcon {
    flex-shrink: 0;
  }

  .TaskItem-title {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    font-size: ${font_size_sm};
    line-height: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }

  .TaskItem-body {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    font-size: ${font_size_sm};
    line-height: 16px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`
